<template>
  <div>
    <h5 class="info-text">Selecciona el pedido</h5>
    <div class="md-layout">
      <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100">
        <md-table v-model="tableDataPlain">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Número">
              <md-radio v-model="radio" :value="item.id">{{ item.id }}</md-radio>
            </md-table-cell>
            <md-table-cell md-label="Fecha">{{ item.date }}</md-table-cell>
            <md-table-cell md-label="Total">{{ item.amount }}</md-table-cell>
            <md-table-cell md-label="Estado">
              <badge type="success">{{ item.state }}</badge>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components";

export default {
  components: {
    IconCheckbox,
  },
  data() {
    return {
      radio: null,
      model: {
        design: false,
        code: true,
        develop: false,
      },
      tableDataPlain: [
        {
          id: "ES83293-234",
          date: "2018-12-06",
          amount: "33,73€",
          state: "Entregado",
        },
        {
          id: "ES83293-233",
          date: "2018-12-06",
          amount: "36,78€",
          state: "Entregado",
        },
        {
          id: "ES83293-232",
          date: "2018-12-06",
          amount: "56,12€",
          state: "Entregado",
        },
      ],
    };
  },
  methods: {
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
  },
};
</script>
<style>
</style>
